import React from 'react';
// bootstrap
import Container from 'react-bootstrap/Container';
// utils
import { Colors } from '_styles';

const Card = (props) => {

    const divStyles = {
        boxShadow: '0px 2px 8px 0px rgba(99, 99, 99, 0.2)',
        borderRadius: 10,
        borderTopStyle: 'solid',
        borderTopWidth: 5,
        borderLeftWidth: 1, borderRightWidth: 1, borderBottomWidth: 1, borderStyle: 'solid', borderColor: 'lightgrey',
        borderTopColor: props.decorationColor && props.decorationColor == 'blue' ? Colors.PRM_LIGHT_BLUE : props.decorationColor ? props.decorationColor : Colors.PRM_LIGHT_BLUE,
        overflowY: props.devOverFlowY ? "scroll" : "none",
        maxHeight: props.devMaxHeight ? "400px" : "none",
    };
    return (
        <Container style={divStyles} className={props.className ? props.className : ''}>
            <div style={{ paddingTop: 28, paddingBottom: 28 }}>
                {props.children}
            </div>
        </Container>

    );
};

export default Card;